import { Button } from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import MenuAppBar from './MenuAppBar';
import ReactComponent from './ReactComponent';

class ErrorBoundary extends ReactComponent {
    verDetalhes = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            verDetalhes: observable,
            toggleExibir: action,
            descricaoErro: computed
        });
    }

    componentDidCatch(error, info) {
        runInAction(() => {
            this.errorStore.hasError = true;
            this.errorStore.error = error;
            this.errorStore.info = info.componentStack ? info.componentStack : JSON.stringify(info);
        });
    }

    toggleExibir = () => {
        this.verDetalhes = !this.verDetalhes;
    };

    get descricaoErro() {
        return this.errorStore.error && this.errorStore.error.stack
            ? this.errorStore.error.stack
            : 'Erro não identificado\n' + this.errorStore.error;
    }

    render() {
        if (this.errorStore.hasError) {
            return (
                <Fragment>
                    <MenuAppBar />
                    <div style={{ marginLeft: '1%', marginRight: '1%', display: 'flex', flexDirection: 'column' }}>
                        <h5>Ocorreu um erro no sistema. Tente novamente ou entre em contato com o suporte.</h5>
                        <Button
                            style={{ width: '12%' }}
                            variant="contained"
                            onClick={this.toggleExibir}
                        >
                            Exibir detalhes
                        </Button>
                        <textarea
                            style={{
                                marginTop: '5px',
                                width: '100%',
                                height: '400px',
                                display: !this.verDetalhes ? 'none' : 'flex'
                            }}
                            defaultValue={this.descricaoErro}
                            disabled={true}
                        />
                    </div>
                </Fragment>
            );
        }
        return this.props.children;
    }
}

export default inject('stores')(observer(ErrorBoundary));
